<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/adcUnp/tc-custom/9781398422421.jpg?1684979252475" alt="This image is the cover for the book Crack and Other Short Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crack and Other Short Stories
      </h1>
      <p class="bookDescription body article font2">
        <p>Four compelling and visceral tales – very different in their settings and characters, but alike in their vividness and intensity. <br/>Crack is about the narrator's peculiar encounter with a man he meets smoking crack-cocaine in a phone box. The Prototype is a send-up to late nineteenth-century gothic horror and tells the story of a woman's mayfly resurrection. Our Fathers takes place on the day after the UK EU referendum and it explores the impacts this event had on many people's personal lives. The final story, Etchings on a Stone Wall, is a surreal tale about four people imprisoned in a monolithic structure, who are taunted by the sunlight that shines down from above the wall.<br/>Bart Lambert’s debut short story collection is an energetic and vibrant read, written in a style that is witty, suspenseful and sometimes even shocking.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bart Lambert
      </h2>
      
      <p class="authorDescription body article">Bart Lambert was born in Christchurch, New Zealand, in 1993 to a Kiwi mother and an Irish-London father. He emigrated to England in 2009 and there got involved in local theatre groups and acting courses. He wrote his first play in 2015, which he self-produced, acted in and toured around London and the South of England, performing with a small band of actors. In recent years, his attention has been directed more towards writing and he has been using the contemplative time of lockdown to build up an extensive portfolio.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bc68653